import { render, staticRenderFns } from "./parametreler.vue?vue&type=template&id=538fd1ca"
import script from "./parametreler.vue?vue&type=script&lang=js"
export * from "./parametreler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports